import {
  KeyboardAvoidingView,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
  Image,
  Pressable,
  Modal,
} from "react-native";
import { modalStyleSheet } from "../../components/modalStyle";
import {
  useTogglePasswordVisibility,
  useTogglePasswordVisibilityRepeat,
} from "../../hooks/useTogglePasswordVisibility";

import { useState } from "react";
import * as React from "react";
import CryptoES from "crypto-es";

import Ionicons from "@expo/vector-icons/Ionicons";
import { useNavigation } from "@react-navigation/native";

//RESPONSIVE
import "@expo/match-media";
import { useMediaQuery } from "react-responsive";

import { updateUserData } from "../../api";

import { userChange } from "./ChangePassword";

//TRADUCCION
import { translations } from "../../components/translations";
import { I18n } from "i18n-js";
const i18n = new I18n(translations);
import { ThemeContext } from "../../components/contexts";

//TEMAS
import { useTheme } from "@react-navigation/native";

const ChangePassword2 = (props) => {
  const { colors } = useTheme();

  const { language } = React.useContext(ThemeContext);

  i18n.locale = language;
  i18n.enableFallback = true;

  const [modalVisible, setModalVisible] = useState(false);
  const [modal2Visible, setModal2Visible] = useState(false);

  const { passwordVisibility, rightIcon, handlePasswordVisibility } =
    useTogglePasswordVisibility();
  const {
    passwordVisibilityRepeat,
    rightIconRepeat,
    handlePasswordVisibilityRepeat,
  } = useTogglePasswordVisibilityRepeat();

  const [password, setPassword] = useState({
    id: userChange,
    password: "",
  });
  const [passwordRepeat, setPasswordRepeat] = useState("");

  const handleChange = (name, value) =>
    setPassword({ ...password, [name]: value });

  let buttonStyle;
  let passValid, passEqual;

  const [textfieldStyle1, setTextfieldStyle1] = useState([
    styles.registerInputBox,
    { backgroundColor: colors.texInputBackground, borderColor: colors.main },
  ]);
  const [textfieldStyle2, setTextfieldStyle2] = useState([
    styles.registerInputBox,
    { backgroundColor: colors.texInputBackground, borderColor: colors.main },
  ]);

  //VALIDATION
  let buttonDisabled;
  if (password.password !== "" && passwordRepeat !== "") {
    buttonDisabled = false;
    buttonStyle = [
      styles.nextButton,
      styles.buttonShadow,
      { backgroundColor: colors.main, shadowColor: colors.shadowColor },
    ];
  } else {
    buttonStyle = [
      styles.nextButton,
      { backgroundColor: colors.buttonDisabled },
    ];
    buttonDisabled = true;
  }

  if (password.password.length < 8) {
    passValid = false;
  } else {
    passValid = true;
  }

  if (password.password == passwordRepeat) {
    passEqual = true;
  } else {
    passEqual = false;
  }

  const [displayErrorPass, setdisplayErrorPass] = useState("");
  const [displayErrorEqual, setdisplayErrorEqual] = useState("");

  //NAVIGATION
  const navigation = useNavigation();
  const navigateNext = () => {
    if (passValid) {
      setTextfieldStyle1([
        styles.registerInputBox,
        {
          backgroundColor: colors.texInputBackground,
          borderColor: colors.main,
        },
      ]);
      setdisplayErrorPass("");
    } else {
      setTextfieldStyle1([
        styles.registerInputBox,
        { backgroundColor: colors.errorLight, borderColor: colors.error },
      ]);
      setdisplayErrorPass(i18n.t("contraNoValida"));
    }
    if (passEqual) {
      setTextfieldStyle2([
        styles.registerInputBox,
        {
          backgroundColor: colors.texInputBackground,
          borderColor: colors.main,
        },
      ]);
      setdisplayErrorEqual("");
    } else {
      setTextfieldStyle2([
        styles.registerInputBox,
        { backgroundColor: colors.errorLight, borderColor: colors.error },
      ]);
      setdisplayErrorEqual(i18n.t("contrasNoCoinciden"));
    }

    if (passEqual && passValid) {
      const encryptedPassword = CryptoES.SHA256(password.password).toString();
      updateUserData(userChange, { password: encryptedPassword })
      setModal2Visible(true);
    } else {
      setModalVisible(true);
    }
  };
  const navigateLogin = () => {
    navigation.goBack();
  };


  const isTabletOrMobileDevice = useMediaQuery({
    maxDeviceWidth: 1224,
    // alternatively...
    query: "(max-device-width: 1224px)",
  });

  if (isTabletOrMobileDevice) {
    return (
      <View style={styles.container}>
        <View style={{ marginBottom: 0 }}>
          <Image
            style={styles.loginImage}
            source={require("./../../assets/MSLogo.png")}
          />
        </View>

        <View>
          <Text
            style={{
              fontFamily: "Kodchasan-Regular",
              marginTop: 60,
              textAlign: "center",
              fontSize: 18,
              color: colors.textColor,
            }}
          >
            Parece que estás utilizando un móvil o una tablet.
          </Text>
          <Text
            style={{
              fontFamily: "Kodchasan-Bold",
              marginTop: 60,
              textAlign: "center",
              color: colors.textColor,
            }}
          >
            Por favor utiliza la aplicación oficial.
          </Text>
        </View>
        <View
          style={{
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            overflow: "visible",
          }}
        >
          <TouchableOpacity
            style={{ width: "100%", height: 100, margin: 25 }}
            onPress={() => {
              window.open(
                "https://play.google.com/store/apps/details?id=com.msinvs.msinvs", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/googleplay_img.png",
              }}
            />
          </TouchableOpacity>
          <TouchableOpacity
            style={{ width: "100%", height: 100 }}
            onPress={() => {
              window.open(
                "https://apps.apple.com/es/app/msinvs/id1565847618", '_blank'
              );
            }}
          >
            <Image
              style={{ resizeMode: "contain", width: "100%", height: 100 }}
              source={{
                uri: "https://msinvs.com/webtest/images/appstore_img.png",
              }}
            />
          </TouchableOpacity>
        </View>

        <View
          style={{
            flex: 1,
            alignItems: "flex-end",
            justifyContent: "flex-end",
          }}
        >
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    );
  }



  return (
    <View
      style={[
        styles.container,
        {
          backgroundColor: colors.main,
          justifyContent: "center",
          margin: 0,
          padding: 0,
        },
      ]}
    >
      <View
        style={[
          {
            justifyContent: "flex-start",
            alignItems: "center",
            padding: 70,
            paddingBottom: 0,
            backgroundColor: colors.background,
            borderRadius: 25,
            width: 450,
            height: 750,
          },
          styles.buttonShadow,
        ]}
      >
        <Modal animationType="fade" transparent={true} visible={modal2Visible}>
          <View style={modalStyleSheet.modalContainer}>
            <View
              style={[
                modalStyleSheet.modalBox,
                { backgroundColor: colors.background },
              ]}
            >
              <View style={modalStyleSheet.modalBoxErrorBox}>
                <Text
                  style={[
                    modalStyleSheet.modalBoxWelcomeBody,
                    { color: colors.textColor },
                  ]}
                >
                  {i18n.t("cambioCorrecto")}
                </Text>
              </View>
              <Pressable
                style={[
                  modalStyleSheet.modalClose,
                  { backgroundColor: colors.main },
                ]}
                onPress={() => {
                  navigation.replace("Home")}}
              >
                <Text
                  style={[
                    modalStyleSheet.modalCloseText,
                    { color: colors.buttonTextColor },
                  ]}
                >
                  {i18n.t("deAcuerdo")}
                </Text>
              </Pressable>
            </View>
          </View>
        </Modal>
        <Modal animationType="fade" transparent={true} visible={modalVisible}>
          <View style={modalStyleSheet.modalContainer}>
            <View
              style={[
                modalStyleSheet.modalBox,
                { backgroundColor: colors.background },
              ]}
            >
              <View style={modalStyleSheet.modalBoxErrorBox}>
                <Text
                  style={[
                    modalStyleSheet.modalBoxError,
                    { color: colors.error },
                  ]}
                >
                  {displayErrorPass}
                  {displayErrorEqual}
                </Text>
              </View>
              <Pressable
                style={[
                  modalStyleSheet.modalClose,
                  { backgroundColor: colors.main },
                ]}
                onPress={() => setModalVisible(!modalVisible)}
              >
                <Text
                  style={[
                    modalStyleSheet.modalCloseText,
                    { color: colors.buttonTextColor },
                  ]}
                >
                  {i18n.t("deAcuerdo")}
                </Text>
              </Pressable>
            </View>
          </View>
        </Modal>

        <View style={styles.backButtonContainer}>
          <TouchableOpacity onPress={navigateLogin} style={styles.backButton}>
            <Ionicons
              name="ios-chevron-back"
              size={34}
              color={colors.mainTransparency}
            />
          </TouchableOpacity>
        </View>

        <View style={styles.registerImageContainer}>
          <Image
            style={styles.registerImage}
            source={require("./../../assets/MSLogo.png")}
          />

          <View style={styles.registerHeaderContainer}>
            <Ionicons name="ios-key" size={34} color={colors.main} />
            <Text
              style={[styles.registerHeaderText, { color: colors.textColor }]}
            >
              {i18n.t("nuevaContra")}
            </Text>
          </View>
        </View>
        <KeyboardAvoidingView
          behavior="position"
          style={styles.registerInputContainer}
        >
          <View style={textfieldStyle1}>
            <TextInput
              placeholder={i18n.t("contra")}
              placeholderTextColor={colors.mainTransparency}
              value={password.password}
              onChangeText={(text) => handleChange("password", text)}
              secureTextEntry={passwordVisibility}
              style={[styles.registerInput, { color: colors.main }]}
            />
            <Pressable onPress={handlePasswordVisibility}>
              <Ionicons
                style={styles.visibilityToggle}
                name={rightIcon}
                size={24}
                color={colors.mainTransparency}
              />
            </Pressable>
          </View>
          <View style={textfieldStyle2}>
            <TextInput
              placeholder={i18n.t("repetirContra")}
              placeholderTextColor={colors.mainTransparency}
              value={passwordRepeat}
              onChangeText={(text) => setPasswordRepeat(text)}
              secureTextEntry={passwordVisibilityRepeat}
              style={[styles.registerInput, { color: colors.main }]}
            />
            <Pressable onPress={handlePasswordVisibilityRepeat}>
              <Ionicons
                style={styles.visibilityToggle}
                name={rightIconRepeat}
                size={24}
                color={colors.mainTransparency}
              />
            </Pressable>
          </View>
        </KeyboardAvoidingView>
        <View style={styles.nextButtonContainer}>
          <TouchableOpacity
            disabled={buttonDisabled}
            onPress={navigateNext}
            style={buttonStyle}
          >
            <Text
              style={[styles.nextButtonText, { color: colors.buttonTextColor }]}
            >
              {i18n.t("siguiente")}
            </Text>
          </TouchableOpacity>
          <Text style={[styles.copyrightText, { color: colors.textColor }]}>
            {i18n.t("copyright")}
          </Text>
        </View>
      </View>
    </View>
  );
};

export default ChangePassword2;

const styles = StyleSheet.create({
  container: {
    justifyContent: "flex-start",
    alignItems: "center",
    padding: 70,
    paddingTop: 66,
    paddingBottom: 0,
    minHeight: "100%",
  },

  buttonShadow: {
    shadowOffset: {
      width: 0,
      height: 4,
    },
    shadowOpacity: 0.3,
    shadowRadius: 4,
    elevation: 2,
  },

  //IMAGEN LOGO
  registerImageContainer: {
    margin: "auto",
    width: "100%",
    height: "auto",
    paddingVertical: 0,
    marginBottom: 10,
  },

  registerImage: {
    alignSelf: "center",
    width: 115,
    height: 115,
    marginBottom: 10,
  },

  //OPTIONS
  registerHeaderContainer: {
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    marginBottom: 50,
  },
  registerHeaderText: {
    fontSize: 24,
    fontFamily: "Kodchasan-Bold",
    textAlign: "center",
  },

  //INPUTS
  registerInputContainer: {
    width: "100%",
  },
  registerInputBox: {
    paddingHorizontal: 15,
    paddingVertical: 10,
    marginBottom: 25,
    borderRadius: 10,
    borderStyle: "solid",
    borderWidth: 2,
    flexDirection: "row",
    justifyContent: "space-between",
  },

  registerInput: {
    flex: 1,
    outlineStyle: "none",
    fontFamily: "Kodchasan-Regular",
  },

  visibilityToggle: {
    marginLeft: 10,
  },

  //NEXT BUTTON
  nextButtonContainer: {
    width: "80%",
    flex: 1,
    alignItems: "center",
    justifyContent: "flex-end",
    minHeight: 150,
  },
  nextButton: {
    width: "100%",
    paddingVertical: 10,
    borderRadius: 20,
    textAlign: "center",
    marginBottom: 25,
  },
  nextButtonText: {
    fontSize: 13,
    fontFamily: "Kodchasan-Bold",
    textAlign: "center",
  },
  copyrightText: {
    marginBottom: "15%",
    marginTop: "5%",
    fontFamily: "Kodchasan-Regular",
    textAlign: "center",
  },

  //BACK BUTTON
  backButtonContainer: {
    width: "auto",
    position: "absolute",
    top: 70,
    left: 25,
  },
});
